import { ColumnProps } from "./types"

export const Column = ({ 
  label 
}: ColumnProps) => {
  return (
    <th scope="col">{label}</th>
  )
}